import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerModelos = async (marca, rubro = "auto") => {
    const params = {
        hash: await getApiHash(),
        marca: marca?.label,
        modelo: "",
        rubro
    }
    const headers = { 
        'content-type': 'application/json',
        "Authorization" : 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/getmodelosjson", params,
        {
            headers: headers
        }).then(function (response) {
            return response.data.modelos;
        }).catch(function (error) {
            return error;
    });
};

export default obtenerModelos;